<template>
  <rj-tabs v-model="tabsActive">
    <rj-tab-pane name="1" label="待审批申请单">
      <WaitApproveList />
    </rj-tab-pane>
    <rj-tab-pane name="2" label="已审批申请单">
      <ApprovedList />
    </rj-tab-pane>
  </rj-tabs>
</template>
<script>
import tabPane from '@/components/Tabs/tabPane.vue';
import tabs from '@/components/Tabs/tabs.vue';

// 待审批的申请单列表
import WaitApproveList from './components/WaitApproveList.vue';
// 已审批的申请单列表
import ApprovedList from './components/ApprovedList.vue';
export default {
  name: 'Apply',
  components: {
    'rj-tabs': tabs,
    'rj-tab-pane': tabPane,
    WaitApproveList,
    ApprovedList
  },
  data () {
    return {
      tabsActive: '1'
    };
  },
  mounted () {
    this.$store.dispatch('enumeration/GET_CODE_CHANGE', { dictType: 'CEDD_CHANGE_TYPE', type: 'changeType' });
    this.$store.dispatch('enumeration/GET_CODE_CHANGE', { dictType: 'CEDD_CHANGE_ADVANCE', type: 'changeAdvance' });
    this.$store.dispatch('enumeration/GET_CODE_CHANGE', { dictType: 'CEDD_CHANGE_DELAY', type: 'changeDelay' });
    this.$store.dispatch('enumeration/GET_CODE_CHANGE', { dictType: 'CEDD_CHANGE_STATUS', type: 'changeStatus' });
  }
};
</script>
